import {Text} from "@chakra-ui/react";
import React, {ForwardedRef, forwardRef, MutableRefObject, useEffect, useImperativeHandle,useRef,  useState} from "react";

import {useFont} from "../hooks/FontProvider";

export type TimerComponentStop = {
  stopTimer: () => void;
  startTimer: () => void;
}

type TimerProps = {
  timeLeft: MutableRefObject<number>;
  displayText?: string;
  offsetDisplay?: boolean;
  startOnChange?: boolean;
  onTimerFinished?: (seconds: number) => void;
};

type TimeObj = {
  hours?: number;
  seconds?: number;
  minutes?: number;
};

// TODO: fix-> timerInterval continues after the test is completed
// solution: move timerInterval to Test.tsx
// right now it doesnt affect because updateTime doesnt save if test is complete

/*
 if TimerComponent is a child of Question
 it rerenders every time the user answer a question
 to prevent memory leaks, the interval must be stopped and restarted every time
 currentTime must be a useState for the on screen text to be updated
 the timerInterval id is used globally, when the component rerenders
    the interval is reset and assigned to currentTime
//let timerInterval = 0;
*/

const TimerComponent = forwardRef((props: TimerProps, ref: ForwardedRef<TimerComponentStop>) => {
  const font = useFont().font;
  const originalPath = window.location.pathname;
  let seconds = props.timeLeft.current;
  //let timerInterval = 0;
  const timerInterval = useRef(0);
  const [currentTime, setCurrentTime] = useState<TimeObj>(secondsToTime(seconds));

  function secondsToTime(secs:number) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    return {hours:hours,seconds:seconds,minutes:minutes};
  }
  function timeToSeconds(time:TimeObj) {
    const hours = Math.floor(time.hours? time.hours * (60 * 60) : 0);
    const minutes = Math.floor(time.minutes? time.minutes * 60 : 0);
    const seconds = Math.ceil(time.seconds? time.seconds : 0);

    return hours+minutes+seconds;
  }

  useImperativeHandle(ref, () => ({
    stopTimer() {
      if (timerInterval.current !== 0) window.clearInterval(timerInterval.current);
    },
    startTimer() {
      seconds = props.timeLeft.current
      startTimer();
    }
  }));

  function startTimer() {
    if (seconds > 0) {
      setCurrentTime(secondsToTime(seconds));
      if (timerInterval.current !== 0) window.clearInterval(timerInterval.current);
      timerInterval.current = (window.setInterval(countDown, 1000)); // 1 second
    }
  }

  function saveTime() {
    window.clearInterval(timerInterval.current);
    if (props.onTimerFinished) props.onTimerFinished(props.timeLeft.current);
  }

  function countDown() {
    //  console.log(props.stopTimer)
    //if (props.stopTimer && timerInterval.current) window.clearInterval(timerInterval.current);
    //  console.log(seconds)

    // if the user goes back to another page
    //if (window.location.pathname !== originalPath) {
    //  saveTime();
    //  return;
    //}
    if ( !document.hasFocus() ) return;
    seconds = (seconds - 1);
    props.timeLeft.current = seconds;
    setCurrentTime(secondsToTime(seconds));

    if (seconds === 0) {
      saveTime();
    }
  }

  // start timer on initial render
  useEffect(() => {
    if (props.startOnChange!==false)
      startTimer();
  }, [props.startOnChange]);

  useEffect(() => {
    // when the component rerenders/unmounts
    return () => {
      if (window.location.pathname !== originalPath && timerInterval.current !== 0) {
        saveTime();
      }
      window.clearInterval(timerInterval.current);
    };
  }, []);

  window.onbeforeunload = () => {
    if (timerInterval.current !== 0) {
      saveTime();
    }
  };

  function addPadding(n:number | undefined) {
    return ('00'+n).slice(-2);
  }

  return (
      <Text marginBottom={props.offsetDisplay?"-25px":""} marginRight={props.offsetDisplay?"10px":""}
            position={props.offsetDisplay?"relative":"static"} float={props.offsetDisplay?"right":"none"}
             marginLeft={props.offsetDisplay?"-500px":""} marginTop={props.offsetDisplay?"-10px":""}
            fontWeight={font.weight}
            fontSize={font.buttonText}
      >{props.displayText===undefined ? "Time left: " : props.displayText}
      {addPadding(currentTime.hours)}:{addPadding(currentTime.minutes)}:{addPadding(currentTime.seconds)}</Text>
  );
});

export default TimerComponent;